import { render, staticRenderFns } from "./DigitalInfraSideNav.vue?vue&type=template&id=5833d1c2&"
import script from "./DigitalInfraSideNav.vue?vue&type=script&lang=js&"
export * from "./DigitalInfraSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports